import type { Components, Theme } from "@mui/material/styles";

export const MuiToggleButton: Components<Theme>["MuiToggleButton"] = {
  styleOverrides: {
    root: ({ theme }) => ({
      "lineHeight": 1,
      "fontWeight": "normal",
      "border": "none",
      "display": "flex",
      "&:hover": { backgroundColor: theme.palette.action.hover },
      "&.Mui-selected:hover": { backgroundColor: theme.palette.action.selected },
      "&.Mui-selected": { backgroundColor: theme.palette.action.selected },
      "color": theme.palette.text.primary,
      "gap": theme.spacing(1),
      "&:focus-visible": { outline: "2px solid", outlineColor: theme.palette.primary.main, outlineOffset: 2 },
      "variants": [
        {
          props: { size: "small" },
          style: { fontSize: theme.typography.pxToRem(12), paddingInline: theme.spacing(2) },
        },
      ],
    }),
  },
};
